export const TUTOR_CLIENT_READY_MESSAGE = '__quiklearn_tutor_ready_v1__';
export const TUTOR_OPENING_RECEIVED_PREFIX = '__quiklearn_tutor_opening_received_v1__';

export const latestAgentChatMessage = chatMessages => {
  if (!Array.isArray(chatMessages)) return null;
  for (let index = chatMessages.length - 1; index >= 0; index -= 1) {
    const message = chatMessages[index];
    const text = String(message?.message || '').trim();
    if (!message?.from?.isAgent || !text) continue;
    return {
      id: String(message.id || `${message.timestamp || ''}:${text}`),
      text,
    };
  }
  return null;
};
